import React from 'react';
import { RefreshCw, Droplets, Wind, Eye, Thermometer } from 'lucide-react';
import { 
  formatTemperature, 
  formatWindSpeed, 
  formatWindDirection,
  getWeatherIconUrl,
  getWeatherEmoji 
} from '../services/weatherService';

const WeatherCard = ({ weather, city, onRefresh }) => {
  if (!weather) return null;

  const {
    temperature,
    feels_like,
    humidity,
    pressure,
    description,
    icon,
    wind_speed,
    wind_direction,
    timestamp
  } = weather;

  return (
    <div className="weather-card">
      <div className="weather-header">
        <h2 className="weather-title">
          {getWeatherEmoji(description)} {city}
        </h2>
        <button 
          className="refresh-button"
          onClick={onRefresh}
          title="Refresh weather data"
        >
          <RefreshCw size={20} />
        </button>
      </div>

      <div className="weather-main">
        <div className="weather-info">
          <div className="temperature">
            {formatTemperature(temperature)}
          </div>
          <div className="description">
            {description}
          </div>
          <div className="city-info">
            Feels like {formatTemperature(feels_like)}
          </div>
        </div>

        <div className="weather-icon">
          <img 
            src={getWeatherIconUrl(icon)} 
            alt={description}
            style={{ width: '100px', height: '100px' }}
          />
        </div>
      </div>

      <div className="weather-details">
        <div className="detail-item">
          <Droplets size={24} color="#4A90E2" />
          <div className="detail-label">Humidity</div>
          <div className="detail-value">{humidity}%</div>
        </div>

        <div className="detail-item">
          <Eye size={24} color="#7ED321" />
          <div className="detail-label">Pressure</div>
          <div className="detail-value">{pressure} hPa</div>
        </div>

        <div className="detail-item">
          <Wind size={24} color="#F5A623" />
          <div className="detail-label">Wind</div>
          <div className="detail-value">
            {formatWindSpeed(wind_speed)} {formatWindDirection(wind_direction)}
          </div>
        </div>

        <div className="detail-item">
          <Thermometer size={24} color="#D0021B" />
          <div className="detail-label">Feels Like</div>
          <div className="detail-value">{formatTemperature(feels_like)}</div>
        </div>
      </div>

      <div style={{ 
        marginTop: '1rem', 
        fontSize: '0.8rem', 
        color: '#888', 
        textAlign: 'center' 
      }}>
        Last updated: {new Date(timestamp).toLocaleString()}
      </div>
    </div>
  );
};

export default WeatherCard;
